import React, {PureComponent, Fragment} from 'react';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import moment from 'moment';
import classNames from "classnames";

import './style.scss';
import Table from '../../../components/table';
import {ACTIONS, getGames, getPlaylogSearch, convertDataPlaylogSearch} from './../../../actions/playlog-search';
import {ACTIONS_MASTER, getYearData} from './../../../actions/master';
import {ACTIONS_SEARCH} from './../../../actions/player-search';
import {getSearchCommon} from './../../../actions/player-search';
import Loading from '../../../components/loading';
import {detectIconById, month} from './../../../common/enum/index';
import ClickOutside from "../../../components/ClickOutside";
import styles from "../../../components/dropdown/dropdown.module.css";


class PlaylogSearch extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            dataPlaylogSearch: [],
            listYear: [],
            listGame: [],
            nameBatter: '',
            namePitcher: '',
            showLoading: false,
            year_id: '',
            month: moment().format('MM'),
            game_id: '',
            pitcher_id: '',
            batter_id: '',
            sort: 'bbm1_schedule_tb.scheduled_game_start_datetime',
            order: 'DESC',
            searchPlayer: '',
            listNamePitcher: [],
            listNameBatter: [],
            toggleSuggestSearch: {}
        }
    }
    componentDidMount() {
        this.setState({showLoading: true});
        this.props.getYearData();
    }

    componentDidUpdate() {
        if(this.state.year_id && this.state.listGame && this.state.listGame.length === 0) {
            this.props.getGames({year_id: this.state.year_id, month: this.state.month});
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_PLAYLOG_SEARCH_SUCCESS) {
                this.setState({
                    dataPlaylogSearch: convertDataPlaylogSearch(nextProps.response.data),
                    showLoading: false
                })
            } else {
                this.setState({
                    dataPlaylogSearch: [],
                    showLoading: false
                })
            }
            if (nextProps.statusMaster === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                let currentYear = nextProps.responseMaster.find((obj) => {
                    return obj.year == moment().year();
                })
                this.setState({
                    listYear: nextProps.responseMaster,
                })
                if (!this.state.year_id && currentYear) {
                    this.setState({
                        year_id: currentYear.year_id
                    })
                }
            }
            if (nextProps.status === ACTIONS.GET_GAMES_SUCCESS) {
                this.setState({
                    game_id: '',
                    listGame: nextProps.response ? nextProps.response.data : []
                })
            }
            if (nextProps.statusSearch === ACTIONS_SEARCH.GET_PLAYER_SUCCESS) {
                if (this.state.searchPlayer == '') {
                    return;
                }
                const listName = 'listName' + this.state.searchPlayer.charAt(0).toUpperCase() + this.state.searchPlayer.slice(1);
                this.setState({
                    [listName]: nextProps.responseSearch,
                    toggleSuggestSearch: {[listName]: true}
                })
            }
        }
    }

    changeGame(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    changeOptions(e) {
        const {
            year_id,
            month
        } = this.state;
        let param = {
            year_id: year_id,
            month: month
        };
        param[e.target.name] = e.target.value;
        this.setState(param);
        this.props.getGames(param);
    }

    changePlayerName(e) {
        const playerType = e.target.name.slice(4).toLowerCase();
        this.setState({
            [e.target.name]: e.target.value,
            [playerType + '_id']: ''
        });
    }

    searchPlayer(e, type) {
        if (e.key === 'Enter') {
            const playerType = e.target.name.slice(4).toLowerCase();
            this.setState({
                searchPlayer: playerType,
            });
            this.props.getSearchCommon(e.target.value, type);
        }
    }

    selectPlayer(val, playerType) {
        const camelName = playerType.charAt(0).toUpperCase() + playerType.slice(1);
        this.setState({
            searchPlayer: '',
            ['listName' + camelName]: [],
            ['name' + camelName]: val.player_name,
            [playerType + '_id']: val.id
        })
    }

    notificationSearch() {
        const {
            year_id,
            month,
            game_id,
            pitcher_id,
            batter_id,
            sort,
            order
        } = this.state;
        const data = {
            year_id,
            month,
            game_id,
            pitcher_id,
            batter_id,
            sort,
            order
        };
        let nullCount = 0;
        Object.keys(data).forEach((propName, i) => {
            nullCount += data[propName] ? 0 : 1;
        });
        if (nullCount > 3) {
            toast.error('検索数が膨大なので表示しませんでした。');
            return;
        }

        this.setState({
            showLoading: true
        });

        this.props.getPlaylogSearch(data);
    }

    render() {
        const {history} = this.props;
        const {
            nameBatter,
            namePitcher
        } = this.state;
        return (
            <Fragment>

                <div className="playlog-search">
                    <div className="block-title">
                        <h2 className="block-title__text--main">Playlog Search
                            <span>
                                <i className="fa fa-question-circle"></i>
                                <div className='tooltips-playlog-search'><p>過去のゲーム記録を検索し、1打席単位の結果を閲覧できます。</p></div>
                            </span>
                        </h2>
                    </div>
                    <div className="block-content">
                        <div className="wrapper">
                            <div className="block-control">
                                <select className="form-control" value={this.state.year_id} name='year_id'
                                        onChange={(e) => this.changeOptions(e)}>
                                    <option value='' hidden>シーズン</option>
                                    {
                                        this.state.listYear.map((val, i) => {
                                            return <option key={i} value={val.year_id}>{val.year}</option>
                                        })
                                    }
                                </select>
                                <select className="form-control" value={this.state.month} name='month'
                                        onChange={(e) => this.changeOptions(e)}>
                                    {
                                        month.map((val, i) => {
                                            return <option key={i} value={val.id}>{val.month}</option>;
                                        })
                                    }
                                </select>
                                <select className="form-control" value={this.state.game_id} name='game_id'
                                        onChange={(e) => this.changeGame(e)}>
                                    <option value=''>ゲーム</option>
                                    {
                                        this.state.listGame
                                            ?
                                            this.state.listGame.map((val, i) => {
                                                let day = moment(val.game_date).format('M/D');
                                                return <option key={i}
                                                               value={val.id}>{day} {val.home_team.team_name_s} - {val.away_team.team_name_s}</option>
                                            })
                                            : null
                                    }
                                </select>
                                <div className='wrap-search-pitcher'>
                                    <input type="text" className="searchbox" placeholder="投手名" value={namePitcher}
                                           name='namePitcher' onKeyDown={(e) => this.searchPlayer(e, 'player')}
                                           onChange={(e) => this.changePlayerName(e)}/>
                                    {
                                        this.state.listNamePitcher.length
                                            ?
                                            <ClickOutside onClickOutside={() => this.setState(state => ({
                                                toggleSuggestSearch: {
                                                    ...state.toggleSuggestSearch,
                                                    listNamePitcher: false
                                                }
                                            }))}>
                                                <div className={classNames(styles.blockSuggest, styles.dropdownMenu,
                                                    (this.state.toggleSuggestSearch && this.state.toggleSuggestSearch.listNamePitcher) && styles.displayBlock)}>
                                                    {this.state.listNamePitcher.map((suggestion, index) => {
                                                        return <div onClick={() => this.selectPlayer(suggestion, 'pitcher')} className={styles.dropdownMenuItem} key={index}>
                                                            <div>
                                                                <img style={{width: 20, marginRight: 10}}
                                                                     src={detectIconById(suggestion.team.id)} alt="team-name"/>
                                                                {suggestion.player_name}
                                                                <span style={{
                                                                    color: '#74818A',
                                                                    fontSize: 13,
                                                                    marginLeft: 10
                                                                }}>{suggestion.uniform_number}</span>
                                                            </div>
                                                            <span className="fa fa-search form-control-feedback" />
                                                        </div>
                                                    })}
                                                </div>
                                            </ClickOutside>
                                            : null
                                    }
                                </div>
                                <div className='wrap-search-batter'>
                                    <input type="text" className="searchbox" placeholder="野手名" value={nameBatter}
                                           name='nameBatter' onKeyDown={(e) => this.searchPlayer(e, 'player')}
                                           onChange={(e) => this.changePlayerName(e)}
                                    />
                                    {
                                        this.state.listNameBatter.length
                                            ?
                                            <ClickOutside onClickOutside={() => this.setState(state => ({
                                                toggleSuggestSearch: {
                                                    ...state.toggleSuggestSearch,
                                                    listNameBatter: false
                                                }
                                            }))}>
                                                <div className={classNames(styles.blockSuggest, styles.dropdownMenu,
                                                    (this.state.toggleSuggestSearch && this.state.toggleSuggestSearch.listNameBatter) && styles.displayBlock)}>
                                                    {this.state.listNameBatter.map((suggestion, index) => {
                                                        return <div onClick={() => this.selectPlayer(suggestion, 'batter')} className={styles.dropdownMenuItem} key={index}>
                                                            <div>
                                                                <img style={{width: 20, marginRight: 10}}
                                                                     src={detectIconById(suggestion.team.id)} alt="team-name"/>
                                                                {suggestion.player_name}
                                                                <span style={{
                                                                    color: '#74818A',
                                                                    fontSize: 13,
                                                                    marginLeft: 10
                                                                }}>{suggestion.uniform_number}</span>
                                                            </div>
                                                            <span className="fa fa-search form-control-feedback" />
                                                        </div>
                                                    })}
                                                </div>
                                            </ClickOutside>
                                            : null
                                    }
                                </div>

                                <div onClick={() => this.notificationSearch()} className='btn-search-playlog'>
                                    <img alt="filter" src='/img/ic_search_blue.svg'/>
                                    <span>検索を実行</span>
                                </div>
                            </div>
                            <Table
                                showPagination={false}
                                header={this.props.header}
                                showCheckbox={false}
                                showSearch={false}
                                itemOfPage={this.state.dataPlaylogSearch}
                                openLink={(val) => {
                                    history.push(val.url, {finish: true})
                                }}
                            />
                        </div>
                    </div>
                </div>

                <Loading show={this.state.showLoading}/>
            </Fragment>

        );
    }
}

const mapStateToProps = ({playlogSearch, master, playerPitchers}) => {
    return {
        header: playlogSearch.header,
        dataPlaylogSearch: playlogSearch.dataPlaylogSearch,
        status: playlogSearch.status,
        response: playlogSearch.response,
        responseMaster: master.response,
        statusMaster: master.status,
        statusSearch: playerPitchers.status,
        responseSearch: playerPitchers.response,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPlaylogSearch: (data) => {
            dispatch(getPlaylogSearch(data))
        },
        getYearData: () => {
            dispatch(getYearData())
        },
        getGames: (date) => {
            dispatch(getGames(date))
        },
        getSearchCommon: (text, type) => {
            dispatch(getSearchCommon(text, type));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(PlaylogSearch);
